import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from 'react-router-dom'
import queryString from 'query-string'
import { ROLES } from 'src/tools'
import { useAuth } from 'src/contexts/auth.context'

import { UserLayout } from 'src/pages/layouts/user.layout'
import { TeacherMenu } from 'src/pages/layouts/partials/teacher-menu'
import { StudentMenu } from 'src/pages/layouts/partials/student-menu'
import { ParentMenu } from 'src/pages/layouts/partials/parent-menu'
import { AuthorMenu } from 'src/pages/layouts/partials/author-menu'
import { SideBarContextProvider } from 'src/contexts/SideBarContext'

// Front
import { FrontPage } from 'src/pages/front'

// Auth screens
import { Login } from 'src/pages/auth/login'
import { Register } from 'src/pages/auth/register'
import { ForgotPassword } from 'src/pages/auth/forgot-password'
import { ConfirmationLinkSent } from 'src/pages/auth/confirmation-link-sent'
import { ResendLink } from 'src/pages/auth/resend-link'
import { ResendLinkSent } from 'src/pages/auth/resend-link-sent'

// const OtherComponent = React.lazy(() => import('./OtherComponent'));

// Student screens
import { StudentDashboard } from 'src/pages/student/dashboard'
import { StudentLessons } from 'src/pages/student/lessons'
import { StudentRunLesson } from 'src/pages/student/lessons/show'
import { StudentDashboardAwards } from 'src/pages/student/awards'
import { StudentDashboardReportCard } from 'src/pages/student/report-card'
import { StudentAfterSchool } from 'src/pages/student/after-school'
import { StudentHomeworks } from 'src/pages/student/homeworks'
import { StudentHomework } from 'src/pages/student/homeworks/homework'

// Teacher screens
import { TeacherDashboard } from 'src/pages/teacher/dashboard'
import { TeacherStudents } from 'src/pages/teacher/students'
import { TeacherStudentsDetails } from 'src/pages/teacher/students/show'
import { TeacherPractices } from 'src/pages/teacher/practices'
import { TeacherPracticeOptions } from 'src/pages/teacher/practices/options'
import { TeacherEditPractice } from 'src/pages/teacher/practices/edit'
import { TeacherNewPractice } from 'src/pages/teacher/practices/new'
import { TeacherNewAutogeneratedPractice } from 'src/pages/teacher/practices/new-autogenerated'
import { TeacherPracticeQuestions } from 'src/pages/teacher/practices/questions'
import { TeacherNewPracticeQuestion } from 'src/pages/teacher/practices/questions/new'
import { TeacherPracticeQuestion } from 'src/pages/teacher/practices/questions/edit'
import { TeacherVideoLessons } from 'src/pages/teacher/video'

// Teacher classrooms
import { Classrooms } from 'src/pages/teacher/classrooms'
import { NewClassroom } from 'src/pages/teacher/classrooms/new'
import { EditClassroom } from 'src/pages/teacher/classrooms/edit'
import { ClassroomStudents } from 'src/pages/teacher/classrooms/students'

// Parent
import ParentDashboard from 'src/pages/parent/dashboard'
import ChildrenPage from 'src/pages/parent/children'

// Author screens
import { AuthorDashboard } from 'src/pages/author/dashboard'

// For all
import { Invites } from 'src/pages/common/invites'
import { Profile } from 'src/pages/common/profile'

import { Schedule } from 'src/pages/common/schedule'
import { NewSchedule } from 'src/pages/common/schedule/new'
import { EditSchedule } from 'src/pages/common/schedule/edit'

import { Shop } from 'src/pages/common/shop'
import { ShopNew } from 'src/pages/common/shop/new'
import { ShopEdit } from 'src/pages/common/shop/edit'

import { PublicLessons } from 'src/pages/common/public-lessons'
import { PublicLessonsNew } from 'src/pages/common/public-lessons/new'
import { PublicLessonsEdit } from 'src/pages/common/public-lessons/edit'

import { Downloads } from 'src/pages/common/downloads'
import { Notifications } from 'src/pages/common/notifications'

import { Billing } from 'src/pages/common/billing'
import { Settings } from 'src/pages/common/settings'

import { Favorites } from 'src/pages/common/favorites'

import { Marketplace } from 'src/pages/common/marketplace'

import { Empty } from 'src/pages/empty'

import { Library } from 'src/pages/common/library'

import { Playground } from 'src/pages/playground'

import { Draw } from 'src/pages/draw'





import { routes, resource } from './routes'

export default function Navigation() {
  const { user, state, logout } = useAuth()
  const { search } = window.location
  const params = queryString.parse(search)

  if (!state.isFetched) {
    return null
  }

  if (user && params.redirect_to) {
    window.location.href = params.redirect_to as string
    return null
  }

  if (user && params.iframe) {
    return (
      <>
        <h2>You are logged</h2>
        <button
          type="button"
          onClick={() => {
            logout()
          }}
        >
          Logout
        </button>
      </>
    )
  }

  const renderMenu = () => {
    switch (user?.role_id) {
      case ROLES.teacher:
        return <TeacherMenu />
      case ROLES.student:
        return <StudentMenu />
      case ROLES.parent:
        return <ParentMenu user={user} />
      case ROLES.author:
        return <AuthorMenu />
      default:
        return null
    }
  }

  const RenderPracticesRoutes = () =>
    ['practices', 'tests'].map((type) => {
      const res = resource(type)

      return (
        <>
          <Route
            key={res.index}
            exact
            path={res.index}
            component={TeacherPractices}
          />
          <Route
            key={res.options}
            path={res.options}
            component={TeacherPracticeOptions}
          />
          <Route
            key={res.new}
            path={res.new}
            component={TeacherNewPractice}
          />
          <Route
            key={res.new_auto}
            path={res.new_auto}
            component={TeacherNewAutogeneratedPractice}
          />
          <Route
            key={res.edit(':id')}
            path={res.edit(':id')}
            component={TeacherEditPractice}
          />

          <Route
            key={res.questions.index(':id')}
            exact
            path={res.questions.index(':id')}
            component={TeacherPracticeQuestions}
          />
          <Route
            key={res.questions.new(':id')}
            exact
            path={res.questions.new(':id')}
            component={TeacherNewPracticeQuestion}
          />
          <Route
            key={res.questions.edit(':id', ':questionId')}
            path={res.questions.edit(':id', ':questionId')}
            component={TeacherPracticeQuestion}
          />
        </>
      )
    })

  return (
    <Router>
      {user ? (
        <Switch>
          <Route exact path={routes.front} component={FrontPage} />
          <SideBarContextProvider menu={renderMenu()}>
            <UserLayout>
              {/* Common routes */}
              <Route path={routes.messages.index} component={Empty} />
              <Route path={routes.settings.index} component={Settings} />
              <Route path={routes.notifications.index} component={Notifications} />
              <Route path={routes.invites.index} component={Invites} />
              <Route path={routes.marketplace.index} component={Marketplace} />
              <Route path={routes.billing.index} component={Billing} />
              <Route path={routes.profile.index} component={Profile} />
              <Route exact path={routes.timetable.index} component={Schedule} />
              <Route exact path={routes.timetable.day(':date')} component={Schedule} />
              <Route path={routes.timetable.new(':date')} component={NewSchedule} />
              <Route path={routes.timetable.edit(':id')} component={EditSchedule} />
              <Route path={routes.favorites.index} component={Favorites} />
              <Route path={routes.library.index} component={Library} />
              <Route path={routes.playground} component={Playground} />

              <Route path={routes.draw} component={Draw} />

              {/* Routes for Teacher */}
              {user.role_id === ROLES.teacher && (
                <>
                  {/* Home */}
                  <Route exact path={routes.login}>
                    <Redirect to={routes.root} />
                  </Route>
                  <Route exact path={routes.root} component={TeacherDashboard} />

                  {/* Students */}
                  <Route exact path={routes.students.index} component={TeacherStudents} />
                  <Route exact path={routes.students.show(':id')} component={TeacherStudentsDetails} />

                  {/* Classrooms */}
                  <Route exact path={routes.classrooms.index} component={Classrooms} />
                  <Route path={routes.classrooms.new} component={NewClassroom} />
                  <Route path={routes.classrooms.edit(':id')} component={EditClassroom} />
                  <Route path={routes.classrooms.students(':id')} component={ClassroomStudents} />
                  <Route path={routes.report_card} component={Empty} />

                  {/* Practices */}
                  {RenderPracticesRoutes()}
                  <Route exact path={routes.video.index} component={TeacherVideoLessons} />

                  {/* Downloads */}
                  <Route path={routes.downloads.index} component={Downloads} />

                  {/* Printables */}
                  <Route exact path={routes.printables.index} component={Shop} />
                  <Route path={routes.printables.new} component={ShopNew} />
                  <Route path={routes.printables.edit(':id')} component={ShopEdit} />

                  {/* Printables */}
                  <Route exact path={routes.public_lessons.index} component={PublicLessons} />
                  <Route path={routes.public_lessons.new} component={PublicLessonsNew} />
                  <Route path={routes.public_lessons.edit(':id')} component={PublicLessonsEdit} />
                </>
              )}

              {/* Routes for Student */}
              {user.role_id === ROLES.student && (
                <>
                  <Route exact path={routes.login}>
                    <Redirect to="/dashboard" />
                  </Route>

                  <Route exact path={routes.dashboard.report_card.index} component={StudentDashboardReportCard} />
                  <Route exact path={routes.dashboard.awards.index} component={StudentDashboardAwards} />
                  <Route exact path={routes.dashboard.teachers.index} component={Empty} />
                  <Route exact path={routes.dashboard.friends.index} component={Empty} />
                  <Route exact path={routes.dashboard.index} component={StudentDashboard} />
                  <Route exact path={routes.dashboard.day(':date')} component={StudentDashboard} />

                  <Route exact path={routes.lessons.index} component={StudentLessons} />
                  <Route path={routes.lessons.new} component={StudentLessons} />
                  <Route path={routes.lessons.late} component={StudentLessons} />
                  <Route path={routes.lessons.history} component={StudentLessons} />

                  <Route path={routes.lessons.queue(':id')} component={StudentRunLesson} />

                  <Route exact path={routes.after_school.index} component={StudentAfterSchool} />
                  <Route exact path={routes.after_school.games.index} component={StudentAfterSchool} />
                  <Route exact path={routes.after_school.reading.index} component={StudentAfterSchool} />
                  <Route exact path={routes.after_school.sport.index} component={StudentAfterSchool} />
                  <Route exact path={routes.after_school.videos.index} component={StudentAfterSchool} />

                  {/* Downloads */}
                  <Route path={routes.downloads.index} component={Downloads} />

                  <Route exact path={routes.printables.index} component={Shop} />


                  <Route exact path={routes.homeworks.index} component={StudentHomeworks} />
                  <Route path={routes.homeworks.show(':id')} component={StudentHomework} />

                  <Route exact path={routes.root}>
                    <Redirect to="/dashboard" />
                  </Route>
                </>
              )}


              {/* PARENT ROLE */}
              {user.role_id === ROLES.parent && (
                <>
                  <Route exact path={routes.login}>
                    <Redirect to={routes.root} />
                  </Route>

                  <Route exact path={routes.root} component={ParentDashboard} />

                  <Route exact path={routes.children.index} component={ChildrenPage} />
                  <Route exact path={routes.children.show(':id')} component={TeacherStudentsDetails} />

                  <Route path={routes.report_card} component={Empty} />

                  {/* Practices */}
                  {RenderPracticesRoutes()}

                  <Route path={routes.downloads.index} component={Downloads} />

                  {/* Printables */}
                  <Route exact path={routes.printables.index} component={Shop} />
                </>
              )}

              {user.role_id === ROLES.author && (
                <>
                  <Route exact path={routes.login}>
                    <Redirect to={routes.root} />
                  </Route>
                  <Route exact path={routes.root} component={AuthorDashboard} />

                  {/* Practices */}
                  {RenderPracticesRoutes()}

                  <Route path={routes.downloads.index} component={Downloads} />

                  <Route exact path={routes.printables.index} component={Shop} />
                  <Route path={routes.printables.new} component={ShopNew} />
                  <Route path={routes.printables.edit(':id')} component={ShopEdit} />

                  <Route exact path={routes.public_lessons.index} component={PublicLessons} />
                  <Route path={routes.public_lessons.new} component={PublicLessonsNew} />
                  <Route path={routes.public_lessons.edit(':id')} component={PublicLessonsEdit} />
                </>
              )}
            </UserLayout>
          </SideBarContextProvider>
        </Switch>
      ) : (
        <Switch>
          <Route exact path={routes.front} component={FrontPage} />
          <Route path={routes.login} component={Login} />
          <Route path={routes.register} component={Register} />
          <Route path={routes.forgot_password} component={ForgotPassword} />
          <Route
            path={routes.confirmation_link_sent}
            component={ConfirmationLinkSent}
          />
          <Route path={routes.resend_link} component={ResendLink} />
          <Route path={routes.resend_link_sent} component={ResendLinkSent} />
          <Route path="*">
            <Redirect to={`/login${search}`} />
          </Route>
        </Switch>
      )}
      {state.needRedirect && <Redirect to={`/login${search}`} />}
    </Router>
  )
}
